import React from "react";
import copy from "copy-to-clipboard";
import CopyIcon from "@mui/icons-material/ContentCopy";
import {useTranslation} from "react-i18next";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";

type CopyToClipboardProps = {
    text: string | number;
    isAlwaysVisible?: boolean;
};
const CopyToClipboard = ({text, isAlwaysVisible}: CopyToClipboardProps) => {
    const {t} = useTranslation();
    const [showSuccess, setShowSuccess] = React.useState(false);

    const handleCopy = () => {
        if (!showSuccess) {
            copy(`${text}`);
            setShowSuccess(true);
            setTimeout(() => {
                setShowSuccess(false);
            }, 2000);
        }
    };

    return (
        <Box
            sx={{
                visibility: isAlwaysVisible || showSuccess ? "visible" : "hidden",
                ".hasCopy:hover &": {
                    visibility: "visible",
                },
            }}
        >
            <Tooltip title={showSuccess ? t("tooltip_copied") : t("tooltip_copyToClipboard")}>
                <IconButton onClick={handleCopy}>{showSuccess ? <CheckIcon /> : <CopyIcon />}</IconButton>
            </Tooltip>
        </Box>
    );
};

export default CopyToClipboard;
